import { Check } from "lucide-react"
import { cn } from "@/lib/utils"

interface ProgressIndicatorProps {
  steps: string[]
  currentStep: number
  completedSteps: number[]
  onStepClick: (step: number) => void
}

export function ProgressIndicator({ steps, currentStep, completedSteps, onStepClick }: ProgressIndicatorProps) {
  return (
    <div className="relative flex justify-between mb-8">
      {/* Background line */}
      <div className="absolute top-5 left-0 right-0 h-[2px] bg-gray-400 -z-10">
        {/* Green progress line */}
        <div
          className="h-full bg-green-600 transition-all duration-300"
          style={{
            width: `${(Math.max(...completedSteps) / (steps.length - 1)) * 100}%`,
          }}
        />
      </div>

      {steps.map((step:string, index:number) => (
        <div key={step} className="flex flex-col items-center gap-2">
          <button
            type="button"
            onClick={() => onStepClick(index)}
            className={cn(
              "h-10 min-w-[40px] rounded-full flex items-center justify-center px-3 transition-colors relative",
              "hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary",
              index === currentStep && "bg-teal100 text-white",
              index !== currentStep && !completedSteps.includes(index) && "bg-gray-100 text-gray-500",
              completedSteps.includes(index) && "bg-green-600 text-white",
            )}
          >
            {completedSteps.includes(index) ? (
              <Check className="h-4 w-4" />
            ) : (
              <span className="text-sm font-medium">{index + 1}</span>
            )}
          </button>
          <span className="text-xs text-gray-600">{step}</span>
        </div>
      ))}
    </div>
  )
}

